import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Lodash
import _isFunction from 'lodash/isFunction';

// Utils
import { getFormattedDateTime, DATE_TIME_FORMATS } from '@tekion/tekion-base/utils/dateUtils';
import { withConfigConsumer } from 'antd/lib/config-provider';

// Components
import { Input, Popover } from 'antd';
import Calendar from './molecules/Calendar';

// Constants
import { POPOVER_ALIGN_CONFIG } from './constants/customFormatMonthPicker.styles';
import { calendarIconElement } from './constants/customFormatMonthPicker.component';
import styles from '../input.module.scss';
var CustomFormatMonthPicker = function CustomFormatMonthPicker(props) {
  var _cx;
  var className = props.className,
    disabledDate = props.disabledDate,
    value = props.value,
    onChange = props.onChange,
    readOnly = props.readOnly,
    format = props.format,
    disabled = props.disabled,
    prefixCls = props.prefixCls;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    date = _useState2[0],
    setDate = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopover = _useState4[0],
    setShowPopover = _useState4[1];
  var handleSelect = useCallback(function (selectedDate) {
    setShowPopover(false);
    onChange(selectedDate);
  }, [onChange]);
  var monthCalendarElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(Calendar, {
      prefixCls: prefixCls,
      className: className,
      mode: "month",
      onSelect: handleSelect,
      onChange: setDate,
      disabledDate: disabledDate,
      value: date
    });
  }, [className, handleSelect, disabledDate, date, prefixCls]);
  useEffect(function () {
    setDate(value);
  }, [value]);
  var wrapperClass = cx(styles.inputWrapper, className, (_cx = {}, _defineProperty(_cx, styles.readOnly, readOnly), _defineProperty(_cx, styles.disabled, disabled), _cx));
  var formattedDate = value && (_isFunction(format) ? format(value) : getFormattedDateTime(value, format));
  return /*#__PURE__*/React.createElement(Popover, {
    visible: showPopover,
    placement: "bottomLeft",
    trigger: "click",
    onVisibleChange: setShowPopover,
    content: monthCalendarElement,
    align: POPOVER_ALIGN_CONFIG
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.input, " ").concat(styles.suffixPadding)
  }, /*#__PURE__*/React.createElement(Input, {
    className: "".concat(prefixCls, "-picker-input"),
    value: formattedDate,
    placeholder: __('Select Month'),
    suffix: calendarIconElement,
    readOnly: true
  }))));
};
CustomFormatMonthPicker.propTypes = {
  prefixCls: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabledDate: PropTypes.func,
  value: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  format: PropTypes.oneOf([PropTypes.string, PropTypes.func]),
  disabled: PropTypes.bool
};
CustomFormatMonthPicker.defaultProps = {
  className: undefined,
  disabledDate: undefined,
  value: undefined,
  onChange: undefined,
  readOnly: false,
  format: DATE_TIME_FORMATS.ABBREVIATED_MONTH_COMMA_FULL_YEAR,
  disabled: false
};
export default withConfigConsumer({
  prefixCls: 'calendar'
})(CustomFormatMonthPicker);